/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./content.vue?vue&type=template&id=ae8b381c&scoped=true&"
import script from "./content.vue?vue&type=script&lang=ts&"
export * from "./content.vue?vue&type=script&lang=ts&"
import style0 from "./content.vue?vue&type=style&index=0&id=ae8b381c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b381c",
  null
  
)

export default component.exports